import { requestMain, requestBaseService } from './index'
import { generateQueryString, GenerateQueryV2 } from '../../utils/query'

export const fetchBuyStock = payload => {
  const params = generateQueryString(payload.params)
  return requestMain({
    url: `buy-stock?${params}`,
    method: 'get'
  })
}

export const postBuyStock = payload => {
  return requestMain({
    url: 'buy-stock',
    method: 'POST',
    data: payload.body
  })
}

export const fetchSellStock = payload => {
  const params = generateQueryString(payload.params)
  return requestMain({
    url: `sell-all?${params}`,
    method: 'get'
  })
}

export const postSellStock = payload => {
  return requestMain({
    url: 'sell-all',
    method: 'POST',
    data: payload.body
  })
}

export const getAnalysisStock = payload => {
  const params = generateQueryString(payload.params)
  return requestMain({
    url: `get-analysis?${params}`,
    method: 'get'
  })
}

export const getListStocks = payload => {
  const params = GenerateQueryV2(payload)
  return requestBaseService({
    url: `emitten/ex/v1/stocks?${params}`,
    method: 'GET'
  })
}

export const getDetailStocksCode = payload => {
  return requestBaseService({
    url: `emitten/ex/v1/stocks/${payload}/code`,
    method: 'GET'
  })
}

export const getLastPrice = payload => {
  return requestBaseService({
    url: `/emitten/ex/v1/stock-prices/${payload}/last-price`,
    method: 'GET'
  })
}

export const getChartStock = payload => {
  const params = generateQueryString(payload.params)
  return requestMain({
    url: `chart/get-by-code?${params}`,
    method: 'get'
  })
}

export const getAnalystStock = payload => {
  const params = generateQueryString(payload.params)
  return requestMain({
    url: `analysis-detail/getbyname?${params}`,
    method: 'get'
  })
}

const Stock = {
  fetchBuyStock,
  postBuyStock,
  fetchSellStock,
  postSellStock,
  getAnalysisStock,
  getListStocks,
  getDetailStocksCode,
  getLastPrice,
  getChartStock,
  getAnalystStock,
}

export default Stock
